
import InputDropDown from "~/cms/blocks/components/CalculatorBlock/InputDropDown.vue";
export default {
  name: "SectionCities",

  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    section: {
      type: Object,
      default: () => {
        return {}
      }
    },
    indexForm: {
      type: Number,
      default: 0
    }
  },

  computed: {
    values: function () {
      return this.form?.[this.indexForm] || {}
    }
  },

  components: {
    InputDropDown
  },

  mounted: function () {
    this.inputFocusFrom()
  },

  methods: {
    changeForm: function (val, name) {
      let values = {...this.values};
      values[name] = val;

      let form = {...this.form}
      form[this.indexForm] = values;

      this.$emit('change', form);

      if (name === 'Откуда') {
        this.inputFocusTo();
      }
    },

    inputFocusFrom: function () {
      if (this.values?.['Откуда']) {
        return;
      }
      if (!this.$refs.refInputDropDownFrom) {
        setTimeout(() => {
          this.inputFocusFrom();
        }, 200)
        return
      }
      this.$refs.refInputDropDownFrom.inputFocusSet()
    },
    inputFocusTo: function () {
      if (this.values?.['Куда']) {
        return;
      }
      if (!this.$refs.refInputDropDownTo) {
        setTimeout(() => {
          this.inputFocusTo();
        }, 200)
        return
      }
      this.$refs.refInputDropDownTo.inputFocusSet()
    },
  }
}
